import _ from "lodash";
import React from "react";
import classes from "./AttachmentLoaderMenu.scss";
import { compose } from "lib/apolloClient";
import AttachmentLoader from "../AttachmentLoader";
import AnimateHeight from "UIComponents/AnimateHeight";
import I18nHOC from "UIComponents/I18nHOC";
import classNames from "classnames";
import { getCountString } from "Utils";
import { ChevronDownOutlined } from "@toddle-edu/ds-icons";
import { connect } from "react-redux";

class AttachmentLoaderMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { isEnable: true };
  }

  toggleIsEnable = () => {
    this.setState({ isEnable: !this.state.isEnable });
  };
  render() {
    const { progressOfUploads, t } = this.props;
    const filteredProgressOfUploads = _.filter(
      progressOfUploads,
      item => !_.get(item, "hideToastProgress", false)
    );

    const uploadingIds = Object.keys(filteredProgressOfUploads);
    const uploadingIdsLength = _.get(uploadingIds, "length", 0);
    const { isEnable } = this.state;
    const arrowStyle = classNames(
      { [classes.arrowContainer]: true },
      { [classes.openArrow]: isEnable },
      { [classes.closeArrow]: !isEnable }
    );
    const fileString = getCountString({
      count: uploadingIdsLength,
      singularText: "File",
      pluralText: "Files",
      shouldShowZero: true,
    });

    return uploadingIdsLength > 0 ? (
      <div className={classes.container}>
        <div className={classes.headerContainer} onClick={this.toggleIsEnable}>
          <div className={classes.headerText}>
            {t("common:processing_with_label", {
              label: fileString,
            })}
          </div>
          <ChevronDownOutlined
            variant="subtle"
            size="xxx-small"
            className={arrowStyle}
          ></ChevronDownOutlined>
        </div>
        <AnimateHeight duration={300} height={!isEnable ? 0 : "auto"}>
          <div className={classes.scrollContainer}>
            {_.map(uploadingIds, key => {
              return (
                <AttachmentLoader
                  item={filteredProgressOfUploads[key]}
                  key={key}
                />
              );
            })}
          </div>
        </AnimateHeight>
      </div>
    ) : null;
  }
}

const mapStateToProps = state => {
  const progressOfUploads = _.get(state, "app_services.progressOfUploads");

  return {
    progressOfUploads,
  };
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps)
)(AttachmentLoaderMenu);
